const EmployeeInfoChanges = ["HI", "ST", "RH", "PC", "TE"];

export const EMPLOYEE_INFO_CHANGES = EmployeeInfoChanges;
